import React from "react";
import { withTranslation } from "react-i18next";
import { BusinessAdministrationPanelView } from "../../views";
import {
  LocalStorageService,
  ClientCompanyService,
  ClientService,
  StatusApplicationTypeService
} from "../../../services/index";
import moment from "moment";
import "moment/locale/es";
import { NIL as NIL_UUID } from "uuid";
import { businessIconDefault } from "../../../assets/logos/icons";

import BusinessAdministrationValidator from "../../../validators/business-administration.validator";

class BusinessAdministrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      planName: "",
      signsAvailable: "",
      totalAvailableSigns: "",
      totalPendingSign: "",
      totalSigns: "",
      expirationDate: "",
      contractPlanExist: false,
      title: props.t("configurationPanelView.titleContracts"),
      clientCompany: [],
      token: "",
      showCompletedRequesting: false,
      showErrorRequesting: false,
      shouldRefresh: false,
      client: {},
      message: " ",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      userInformation: "",
      imageProfile: "",
      optionsTypeBusiness: [
        { typeOfCompany: "A.C." },
        { typeOfCompany: "S. de R.L. de C.V." },
        { typeOfCompany: "S.A. de C.V." },
        { typeOfCompany: "S.A.B. de C.V." },
        { typeOfCompany: "S.A.S. de C.V." },
        { typeOfCompany: "S.C." },
        { typeOfCompany: "S.A.P.I. de C.V." },
        { typeOfCompany: "A.B.P." }
      ],
      optionsBusinessTurnover: [
        { turnOfTheCompany: "Comercial" },
        { turnOfTheCompany: "Industrial" },
        { turnOfTheCompany: "Servicio" },
      ],
      optionsFilter: [
        {
          active: NIL_UUID,
          status: this.props.t("businessAdministrationPanelView.options.all"),
        },
        {
          active: true,
          status: this.props.t("businessAdministrationPanelView.options.active"),
        },
        {
          active: null,
          status: this.props.t("businessAdministrationPanelView.options.inactive"),
        },
      ],
      procedureManager: false,
      pathView: ''
    };
  }

  token = {};
  timezone = ""
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  statusApplicationTypeService = new StatusApplicationTypeService(this.url);
  clientCompanyService = new ClientCompanyService(this.url);
  preferenceService = new ClientService(this.url)
  validators = BusinessAdministrationValidator(this.props.t);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.timezone = this.localStorageService.getLocalStorageItem("timezone");
    this.user = this.localStorageService.getLocalStorageItem("user");
    let urlArr = window.location.href.split("/");
    let path = (urlArr) ? urlArr[4] : ''
    try {
      let userPreferences = await this.preferenceService.getClientPreferences(this.token, this.timezone);
      let procedureManager = userPreferences.data.find(preference => preference.preferenceName === process.env.REACT_APP_PREFERENCE_FREELANCE && preference.booleanValue)
      let userInformation = this.user.userMetaData.userA3Cloud;

      let clientsCompanyInfo = await this.clientCompanyService.getClientCompany(
        userInformation.clientId,
        this.token,
        process.env.REACT_APP_ENDPOINT_CLIENT_COMPANY_ORIGIN_COMPANIES
      );

      moment.locale("es");
      clientsCompanyInfo.data.map((client) => {
        client.clientName = client.company.businessName;
        let dateModification = client.updatedDate.split("T")[0];
        let dateParse = moment(dateModification)
          .format("DD/MMM/YYYY")
          .replace(/\./g, "");
        dateParse = dateParse.replaceAll('.').toLocaleLowerCase()
        client.lastModificationDate = dateParse
        client.status = client.company.status;
        client.imgProfile =
          client.company.logo === null
            ? businessIconDefault
            : client.company.logo;
        client.companyName = client.company.companyName;
        client.turnOfTheCompany = client.company.turnOfTheCompany;
        client.typeOfCompany = client.company.typeOfCompany;

        return client;
      });

      let companiessToShow = []
      if (path === 'entities-administration') {
        let statusByKeyGroup = await this.statusApplicationTypeService.getStatusApplicationType(this.token, "registryType")
        let registryTypes = statusByKeyGroup.data.map(item => { return { key: item.value } })
        registryTypes = registryTypes.filter(type => type.key !== process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
        let entitites = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_PERSON_ENTITY || company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_ORGANIZATION_ENTITY)
        companiessToShow = entitites

        this.setState({
          registryTypes: registryTypes,
          procedureManager: true, optionsFilter:
            [
              {
                active: NIL_UUID,
                status: this.props.t("businessAdministrationPanelView.options.all"),
              },
              {
                value: "entityActive",
                status: this.props.t("businessAdministrationPanelView.options.active.entities"),
              },
              {
                value: "entityInactive",
                status: this.props.t("businessAdministrationPanelView.options.inactive.entities"),
              },
            ]
        })

      } else {
        let companies = clientsCompanyInfo.data.filter((company) => company.company.registryType === process.env.REACT_APP_STATUS_APPLICATION_TYPE_BUSINESS_REASON)
        companiessToShow = companies
      }

      this.setState({
        userInformation: userInformation,
        clientCompany: companiessToShow,
        token: this.token,
        loading: false,
        imageProfile: businessIconDefault,
        pathView: path
      });
    } catch (error) {
      this.props.history.push("/configuration");
      this.setState({
        clientCompany: [],
        loading: false,
      });
    }
  }

  //Function to change image profile
  onChangeImgProfile = async (e) => {
    let fileIn = document.getElementById("fileUploadImgProfile");
    let fileOut = document.getElementById("imgProfile");

    if (e.target.files && e.target.files[0]) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => (fileOut.src = e.target.result);
      fileReader.readAsDataURL(e.target.files[0]);
      this.setState({
        imageProfile: e.target.files[0],
      });
    } else {
      this.setState({
        imageProfile: businessIconDefault,
      });
    }
  };

  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleCompletedRequesting = (value, message, clientCompany) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            clientCompany: clientCompany,
          });
        }, 4000);
      }
    );
  };

  toggleCompleted = (value, message) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: ""
          });
        }, 4000);
      }
    );
  }

  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false, message: "" });
        }, 5000);
      }
    );
  };

  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showWarningRequesting: false, message: "" });
        }, 5000);
      }
    );
  };

  render() {
    return (
      <BusinessAdministrationPanelView
        {...this.state}
        history={this.props.history}
        forceRefresh={this.forceRefresh}
        validators={this.validators}
        onChangeImgProfile={this.onChangeImgProfile}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleCompleted={this.toggleCompleted}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
      />
    );
  }
}

export default withTranslation()(BusinessAdministrationAction);
